"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LearningComponent = void 0;
exports.RenderLearningComponent = RenderLearningComponent;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const webexUI_1 = require("webexUI");
const FilterableList_1 = require("Views/Partials/Components/FilterableList");
const helpers_1 = require("Views/Partials/Components/TableCore/helpers");
const TableCore_1 = require("Views/Partials/Components/TableCore/TableCore");
const typings_1 = require("Views/Partials/Components/TableCore/typings");
const helpers_2 = require("../helpers");
const LearningComponent = ({ dataService, tableCaption, dictionary, tileStatusExpanded, }) => {
    const tableRef = React.useRef();
    const [{ rows, status }, setState] = React.useState({
        rows: null,
        status: null,
    });
    const generateMessage = React.useCallback((statusCode) => {
        switch (statusCode) {
            case FilterableList_1.ListStatusCode.zeroResults:
                return dictionary.zeroResultMessage;
            case FilterableList_1.ListStatusCode.communicationError:
                return dictionary.communicationErrorMessage;
            default:
                return;
        }
    }, [dictionary.communicationErrorMessage, dictionary.zeroResultMessage]);
    const updateStateWithData = React.useCallback(({ coursesData, statusCode }) => {
        setState({
            rows: (0, helpers_2.transformDataToGeneralSchema)(coursesData),
            status: {
                statusCode: statusCode,
                message: generateMessage(statusCode),
            },
        });
    }, [generateMessage]);
    (0, app_1.useDidMount)(() => {
        if (dataService) {
            dataService.getDataForLearningComponent().then(data => updateStateWithData(data));
        }
    });
    const columnsTitles = React.useMemo(() => (0, helpers_2.getTableHeaderData)(rows !== null && rows !== void 0 ? rows : [], dictionary), [dictionary, rows]);
    const filterItems = React.useMemo(() => (0, helpers_1.getUniqueItems)({ columns: columnsTitles, rows: rows !== null && rows !== void 0 ? rows : [] }), [columnsTitles, rows]);
    const tableClassName = React.useMemo(() => `table learning-component w-full ${(rows === null || rows === void 0 ? void 0 : rows.length) === 0 ? 'learning-component-without-rows' : ''}`, [rows === null || rows === void 0 ? void 0 : rows.length]);
    if (!rows) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "spinner-wrapper", children: (0, jsx_runtime_1.jsx)(webexUI_1.Spinner, { className: "learning-component-spinner", visible: true }) }));
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "learning-table-wrap transition-all group relative group-has-[.expand-wrapper-enabled]:overflow-hidden", ref: tableRef, children: (0, jsx_runtime_1.jsx)(TableCore_1.TableCore, { dictionary: dictionary, className: tableClassName, tableType: typings_1.TableTypeEnum.Learning, columns: columnsTitles, status: status, rows: rows, filterItems: filterItems, expandableWrapperClassName: ".learning-table-wrap", tableWrapperClassName: "learning-table-wrapper relative", tableCaption: tableCaption, tileStatusExpanded: tileStatusExpanded }) }));
};
exports.LearningComponent = LearningComponent;
function RenderLearningComponent(data, element) {
    (0, app_1.reactDOMRender)((0, jsx_runtime_1.jsx)(exports.LearningComponent, Object.assign({}, data)), element);
}
